import { WplywContext } from "../../../../../context/wplywContext";
import { useContext, useEffect, useState } from "react";
import { Input, Button, Row, Col, Select } from "antd";
import LineSpacer from "../../../../../components/LineSpacer";
import { useAuth } from "../../../../../context/AuthContext";
import PeselInput from "../../../../../components/PeselInput";
import validatePesel from "../../../../../components/validatePesel";
import Label from "../../../../../components/Label";
import WarningMessage from "../../../../../components/Warning";
import { useSettings } from "../../../../../context/settingsContext";
import FixedNumberInput from "../../../../../components/FixedNumberInput";
import CommentWithFragments from "../../../../../components/CommentWithFragments";

const { TextArea } = Input;
const { Option } = Select;

const SinglePerson = (props) => {
    const { wplyw, setWplyw } = useContext(WplywContext);
    const { personId, index } = props;
    const [open, setOpen] = useState(true);
    const { settings, loading, error } = useSettings();
    const {user} = useAuth() 
    const [personData, setPersonData] = useState(
        wplyw.wplyw_data.data.msr_wplywy.msr_persons.find((person) => person.msr_persons_id === personId) || {}
    );
    const [isVisible, setIsVisible] = useState(true); // Manage visibility for animation

    const isDisabled = wplyw.mode === "preview"; // Disable inputs if mode is "preview"

    const fieldLabels = {
        msr_persons_name: "Imię",
        msr_persons_lastname: "Nazwisko",
        msr_persons_pesel: "PESEL",
        msr_persons_amount: "Kwota",
        msr_persons_deduction: "Kwota odliczenia",
        msr_persons_majority: "Niepełnoletnia lub ubezwłasnowolniona",
        msr_persons_comment: "Uwagi",
        msr_persons_commission: "Prowizja",
        msr_persons_agentid: "Agent",
    };

    const handleFieldChange = (field, value) => {
        const originalPerson = wplyw.wplyw_data.data.msr_wplywy.msr_persons.find(
            (person) => person.msr_persons_id === personId
        );
        const originalValue = originalPerson ? originalPerson[field] : undefined;
        const updatedPersons = wplyw.wplyw_data.data.msr_wplywy.msr_persons.map((person) => {
            if (
                field === "msr_persons_pesel" &&
                person.msr_persons_majority == 1 &&
                validatePesel(value)?.isUnder18
            ) {
                return person.msr_persons_id === personId
                    ? { ...person, msr_persons_majority: 0, [field]: value }
                    : person;
            } else {
                return person.msr_persons_id === personId
                    ? { ...person, [field]: value }
                    : person;
            }
        
        });
    
        setWplyw((prevWplyw) => {
            const changes = [...(prevWplyw.changes || [])];
            const changeIndex = changes.findIndex(
                (change) => change.field === field && change.objectid === originalPerson.msr_persons_own_id
            );
            if (value === originalValue && false) {
                // Remove the change if the value is reverted to the original
                if (changeIndex > -1) {
                    changes.splice(changeIndex, 1);
                }
            } else {
                // Add or update the change
                const changeEntry = {
                    etap: "Osoba",
                    field: field,
                    label: fieldLabels[field] || field,
                    action: "edit",
                    oldValue: originalValue,
                    newValue: value,
                    datetime: Math.floor(new Date().getTime() / 1000),
                    user: user.user.mlg_users_id,
                    objectid: originalPerson.msr_persons_own_id,
                    wplywid: wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_own_id,
                    personid: originalPerson.msr_persons_own_id,
                };
    
                if (changeIndex > -1) {
                    // Update existing change
                    changes[changeIndex] = changeEntry;
                } else {
                    // Add new change
                    changes.push(changeEntry);
                }
            }
    
            return {
                ...prevWplyw,
                wplyw_data: {
                    ...prevWplyw.wplyw_data,
                    data: {
                        ...prevWplyw.wplyw_data.data,
                        msr_wplywy: {
                            ...prevWplyw.wplyw_data.data.msr_wplywy,
                            msr_persons: updatedPersons,
                        },
                    },
                },
                changes,
            };
        });
    
        setPersonData((prev) => ({ ...prev, [field]: value }));
    };
    
    
    

// Function to remove this person with animation
const handleRemovePerson = () => {
    setIsVisible(false); // Trigger fade-out animation
    setTimeout(() => {
        const updatedPersons = wplyw.wplyw_data.data.msr_wplywy.msr_persons.filter(
            (person) => person.msr_persons_id !== personId
        );

        // Prepare the change log
        const changes = [...(wplyw.changes || [])];
        const removedPerson = wplyw.wplyw_data.data.msr_wplywy.msr_persons.find(
            (person) => person.msr_persons_id === personId
        );


        if (removedPerson) {
            changes.push({
                etap: "Osoba",
                field: "msr_persons",
                label: "Usunięto osobę",
                action: "remove",
                oldValue: `Osoba: ${removedPerson.msr_persons_name} ${removedPerson.msr_persons_lastname}`,
                newValue: `Usunięto osobę o ID ${removedPerson.msr_persons_own_id}`,
                datetime: Math.floor(new Date().getTime() / 1000),
                user: user.user.mlg_users_id,
                objectid: removedPerson.msr_persons_own_id,
                wplywid: wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_own_id,
                personid: null,
            });
        }

        // Update the state with changes
        setWplyw({
            ...wplyw,
            wplyw_data: {
                ...wplyw.wplyw_data,
                data: {
                    ...wplyw.wplyw_data.data,
                    msr_wplywy: {
                        ...wplyw.wplyw_data.data.msr_wplywy,
                        msr_persons: updatedPersons,
                    },
                },
            },
            changes, // Include updated changes
        });
    }, 300); // Delay to allow animation to complete
};

    useEffect(() => {
        const person = wplyw.wplyw_data.data.msr_wplywy.msr_persons.find((person) => person.msr_persons_id === personId);
        if (person) {
            setPersonData(person);
        }
    }, [wplyw, personId]);


    return (
        <div
            style={{
                border: "2px solid #BD8136",
                padding: "20px",
                marginBottom: "0px",
                borderRadius: "10px",
                // background: "#f7f7f7",
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? "scale(1)" : "scale(0.9)",
                transition: "all 0.3s ease",
            }}
        >
            <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                <div style={{ fontSize: "20px" }}>#{String(index).padStart(2, '0')}</div>
                <div
                    style={{
                        color: "white",
                        padding: "5px 10px",
                        background: "#BD8136",
                        borderRadius: "5px",
                        width: "fit-content",
                    }}
                >
                    #{personData.msr_persons_own_id}
                </div>
                <div style={{ fontSize: "18px" }}>
                    {personData.msr_persons_name} {personData.msr_persons_lastname}
                </div>
                <Button onClick={() => setOpen(!open)}>{open ? "Zwiń" : "Rozwiń"}</Button>
                <LineSpacer />
                <Button
                    type="primary"
                    danger
                    onClick={handleRemovePerson}
                    disabled={isDisabled}
                    style={{ display: isDisabled ? "none" : "block" }}
                >
                    Usuń osobę
                </Button>
            </div>
            <form style={{ marginTop: "20px", display: open?'block':'none' }}>
                <Row gutter={20}>
                    <Col span={6}>
                        <Label required>Imię</Label>
                        <Input
                            status={personData.msr_persons_name ? 'default' : 'error'}
                            disabled={isDisabled}
                            value={personData.msr_persons_name || ""}
                            onChange={(e) => handleFieldChange("msr_persons_name", e.target.value)}
                            placeholder="Imię"
                        />
                    </Col>
                    <Col span={6}>
                        <Label required>Nazwisko</Label>
                        <Input
                            disabled={isDisabled}
                            status={personData.msr_persons_lastname ? 'default' : 'error'}
                            value={personData.msr_persons_lastname || ""}
                            onChange={(e) => handleFieldChange("msr_persons_lastname", e.target.value)}
                            placeholder="Nazwisko"
                        />
                    </Col>
                    <Col span={6}>
                        <Label>PESEL</Label>
                        <PeselInput
                            disabled={isDisabled}
                            value={personData.msr_persons_pesel || ""}
                            onChange={(value) => handleFieldChange("msr_persons_pesel", value)}
                            placeholder="PESEL"
                        />
                    </Col>
                    <Col span={6}>
                        <Label required>Niepełnoletnia lub ubezwłasnowolniona</Label>
                        <Select
                            style={{ width: "100%" }}
                            disabled={isDisabled}
                            value={personData.msr_persons_majority}
                            onChange={(value) => handleFieldChange("msr_persons_majority", value)}
                            placeholder="Wybierz"
                        >
                            <Option value={1}>Nie</Option>
                            <Option value={0}>Tak</Option>
                        </Select>
                        <WarningMessage display={validatePesel(personData.msr_persons_pesel).isUnder18} text="Podany przez Ciebie PESEL wskazuje, że osoba jest niepełnoletnia."></WarningMessage>
                    </Col>
                </Row>
                <Row gutter={20} style={{ marginTop: "20px" }}>
                    <Col span={12}>
                        <Label required>Kwota wpływu przypadająca na klienta</Label>
                        <FixedNumberInput
                            mode={wplyw.mode}
                            disabled={isDisabled} 
                            value={personData.msr_persons_amount}
                            maxvalue={parseFloat((wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_primary_amount - wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_primary_deduction).toFixed(2))}
                            onChange={(value) => handleFieldChange("msr_persons_amount", value)}
                            placeholder="Kwota"
                            addonAfter="zł"
                            status={(personData.msr_persons_amount && personData.msr_persons_amount) || (parseFloat((wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_primary_amount - wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_primary_deduction).toFixed(2)) == 0 && wplyw.wplyw_data.data.msr_wplywy.msr_persons.length > 0) > 0 ? 'default' : 'error'}
                        />
                    </Col>
                    <Col span={12}>
                        <Label required>Kwota odliczenia przypadająca na klienta</Label>
                        <FixedNumberInput
                            mode={wplyw.mode}
                            disabled={isDisabled}
                            value={personData.msr_persons_deduction}
                            maxvalue={wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_primary_deduction}
                            onChange={(e) => handleFieldChange("msr_persons_deduction", e)}
                            placeholder="Kwota odliczenia przypadająca na klienta"
                            addonAfter="zł"
                            status={personData.msr_persons_deduction != undefined ? 'default' : 'error'}
                        />
                    </Col>
                </Row>
                <div style={{ marginTop: "20px" }}>
                    <Label>Uwagi</Label>
                    <CommentWithFragments 
                        commentName={"msr_persons_comment"}
                        disabled={isDisabled}
                        value={personData.msr_persons_comment || ""}
                        defaultValue={personData.msr_persons_comment || ""}
                        onChange={(e) => handleFieldChange("msr_persons_comment", e.target.value)}
                        placeholder="Uwagi"
                    />
                </div>
                <Row gutter={20}>
                    <Col span={12}>
                        <div style={{ marginTop: "20px" }}>
                            <label>Prowizja z umowy klienta [%]</label>
                            <FixedNumberInput
                                cannull={true}
                                mode={wplyw.mode}
                                disabled={isDisabled} 
                                value={personData.msr_persons_commission || null}
                                maxvalue={100}
                                onChange={(value) => handleFieldChange("msr_persons_commission", value)}
                                placeholder="Brak podanej wartości"
                                addonAfter="%"
                                className="blackplaceholder"
                                status={parseFloat(personData.msr_persons_commission) < parseFloat(settings.commistion_bottom_limit.msr_settings_value) || parseFloat(personData.msr_persons_commission) > parseFloat(settings.commistion_top_limit.msr_settings_value) ? 'warning' : null}
                            />
                            <WarningMessage display={parseFloat(personData.msr_persons_commission) < parseFloat(settings.commistion_bottom_limit.msr_settings_value) || parseFloat(personData.msr_persons_commission) > parseFloat(settings.commistion_top_limit.msr_settings_value)} text={`Wartość prowizji z umowy klienta jest poza przewidzianym przedziałem ${settings.commistion_bottom_limit.msr_settings_value}% a ${settings.commistion_top_limit.msr_settings_value}%`}></WarningMessage>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ marginTop: "20px" }}>
                            <label>Agent</label>
                            <Select
                                style={{ width: "100%" }}
                                disabled={isDisabled}
                                value={personData.msr_persons_agentid}
                                options={[{value: 0, label: 'Brak agenta'}, ...wplyw.wplyw_data.data.default_values.users]}
                                onChange={(value) => handleFieldChange("msr_persons_agentid", value)}
                                placeholder="Wybierz"
                            />
                        </div>
                    </Col>
                </Row>
            </form>
        </div>
    );
};

export default SinglePerson;
